import {Optional} from '@othree.io/optional'

const MaxIdLength: number = 65

export type IdInput = Readonly<{
    prefix?: string
    suffix?: string
}>

/**
 * Builds a resource ID from prefix, identifier, suffix, and version segments.
 * Throws if the result exceeds 65 characters.
 */
export const id = (deps: { version?: string, input: IdInput }) =>
    (identifier: string): string => {
        const generatedId = `${Optional(deps.input.prefix).map(_ => `${_}-`).orElse('')}${identifier}${Optional(deps.input.suffix).map(_ => `-${_}`).orElse('')}${Optional(deps.version).map(_ => `-${_!.toUpperCase()}`).orElse('')}`

        if(generatedId.length > MaxIdLength) {
            throw new Error(`Id should be ${MaxIdLength} characters or less`)
        }

        return generatedId
    }

export type StackAccount = Readonly<{
    accountId: string
    region: string
}>

/** Reads `CDK_DEFAULT_ACCOUNT` and `CDK_DEFAULT_REGION` from the environment. */
export const getStackAccountFromEnv = (): StackAccount => {
    return {
        accountId: String(process.env.CDK_DEFAULT_ACCOUNT),
        region: String(process.env.CDK_DEFAULT_REGION)
    }
}
